import { AppointmentRescheduleReason } from '../../../../../constants'
import { sortBy } from '../../../../../util'

type AppointmentReasonOption = {
  name: string
  value: AppointmentRescheduleReason
}

// Sort by name, with "Other" option last
const sortByAppointmentRescheduleReasonOptions = (options: AppointmentReasonOption[]): AppointmentReasonOption[] =>
  sortBy(options, ({ name, value }) => (value === AppointmentRescheduleReason.OTHER ? `zzz.${name}` : name))

export { sortByAppointmentRescheduleReasonOptions }
